import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import type { FlightShopStep } from "@b2bportal/core-types";
import type { History } from "history";

const POPULATE_FLIGHT_SHOP_QUERY_PARAMS =
  "flightShop/POPULATE_FLIGHT_SHOP_QUERY_PARAMS";

enum FlightShopType {
  PRICE_FREEZE_PURCHASE = "pf-purchase",
  PRICE_FREEZE_EXERCISE = "pf-exercise",
  CHFAR_EXERCISE = "chfar-exercise",
  DEFAULT = "default",
}

const FLIGHT_SHOP_TYPE = "flightShopType";
const PRICE_FREEZE_ID_QUERY_PARAM = "priceFreezeId";

interface IFlightShopOverwriteQueryParams {
  [FLIGHT_SHOP_TYPE]?: FlightShopType;
  [PRICE_FREEZE_ID_QUERY_PARAM]?: string;
  flightShopProgress?: FlightShopStep;
}

export interface IPopulateFlightShopQueryParams {
  type: string;
  history: History;
  prevPath?: string;
  useHistoryPush?: boolean;
  // note: this prop is used to bypass stateDiffersFromQueryParams
  forceQueryUpdate?: boolean;
  newQueryParams?: IFlightShopOverwriteQueryParams;
}

export const populateFlightShopQueryParams = (args: {
  history: History;
  prevPath?: string;
  useHistoryPush?: boolean;
  forceQueryUpdate?: boolean;
  newQueryParams?: IFlightShopOverwriteQueryParams;
}): IPopulateFlightShopQueryParams => ({
  type: POPULATE_FLIGHT_SHOP_QUERY_PARAMS,
  ...args,
});
/**
 * Go back to flight shop from flight checkout
 */
export const useGoBackToFlightShop = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  return useCallback(
    (flightShopStep?: FlightShopStep, useHistoryPush?: boolean) => {
      dispatch(
        populateFlightShopQueryParams({
          history,
          useHistoryPush: useHistoryPush || false,
          newQueryParams: { flightShopProgress: flightShopStep },
        })
      );
    },
    [dispatch, history]
  );
};
